/*
 * Guest checkout.
 *
 * Nobody needs an account to order. The cart asks for an email, then sends
 * the shopper to Shopify's checkout with it as `checkout[email]`, which
 * checkout uses to fill in its Contact field — the address is typed once.
 * Without JavaScript the button still reaches checkout the normal way; the
 * shopper just enters the email again there.
 *
 * The cart drawer rebuilds its footer whenever the cart changes, which would
 * wipe a half-typed address, so the value is kept for the browser session
 * and put back each time the field is rendered.
 */
(function () {
  var KEY = 'jo-guest-email';

  function read() {
    try {
      return sessionStorage.getItem(KEY) || '';
    } catch (e) {
      // Private mode, or storage disabled.
      return '';
    }
  }

  function write(value) {
    try {
      sessionStorage.setItem(KEY, value);
    } catch (e) {
      /* the field just won't survive a re-render */
    }
  }

  if (!customElements.get('jo-guest-checkout')) {
    customElements.define(
      'jo-guest-checkout',
      class extends HTMLElement {
        connectedCallback() {
          var input = this.querySelector('[data-jo-guest-email]');
          if (!input) return;
          if (!input.value) input.value = read();
          input.addEventListener('input', function () {
            write(input.value.trim());
          });
        }
      }
    );
  }

  // By the time `submit` fires the browser has already enforced `required`
  // and the email format, so any value that gets here is a usable address.
  document.addEventListener('submit', function (event) {
    var button = event.submitter;
    if (!button || button.name !== 'checkout') return;

    var panel = button.closest('jo-guest-checkout');
    var input = panel && panel.querySelector('[data-jo-guest-email]');
    var email = input ? input.value.trim() : '';
    if (!email) return;

    event.preventDefault();
    write(email);
    button.setAttribute('aria-disabled', 'true');
    window.location.href = panel.dataset.checkoutUrl + '?checkout[email]=' + encodeURIComponent(email);
  });
})();
